import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';

import { Heading } from '@warrenbrasil/nebraska-web';
import { AllocationChart } from '@/modules/wealth/components/AllocationChart';
import { AllocationChartLegend } from './components/AllocationChartLegend';

import {
  getPortfolioSectorAllocation,
  PortfolioSection
} from '@/modules/wealth/services/portfolio';

interface Props {
  portfolioId: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Allocation',
  props: {
    portfolioId: null
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
}



const isLoading = ref(true);
const hasError = ref(false);
const sections = ref<PortfolioSection[]>([]);
const totalBalance = ref<string | null>(null);
const updatedAt = ref<string | null>(null);
const title = ref<string | null>(null);

const getAllocationData = async () => {
  isLoading.value = true;
  hasError.value = false;

  try {
    const data = await getPortfolioSectorAllocation(props.portfolioId);

    title.value = data.title || 'Alocação por setor';
    sections.value = data.sections;
    totalBalance.value = data.totalBalance.formatted;
    updatedAt.value = data.updatedAt.formatted;
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  await getAllocationData();
});

return { __sfc: true,props, isLoading, hasError, sections, totalBalance, updatedAt, title, getAllocationData, Heading, AllocationChart, AllocationChartLegend }
}

})